import http from 'utils/http';
import { OutboundSipTrunkResponse } from './types';
import { getOutboundSipTrunkUrl } from './apiUrls';

export function getOutboundSipTrunk(workspaceId: string, agentId: string): Promise<OutboundSipTrunkResponse> {
  return http.get(getOutboundSipTrunkUrl(workspaceId, agentId));
}

export function createOutboundSipTrunk(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.post(getOutboundSipTrunkUrl(workspaceId, agentId), payload);
}

export function updateOutboundSipTrunk(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.put(getOutboundSipTrunkUrl(workspaceId, agentId), payload);
}

export function deleteOutboundSipTrunk(workspaceId: string, agentId: string): Promise<any> {
  return http.delete(getOutboundSipTrunkUrl(workspaceId, agentId));
}
